<template>
  <BasicLayout>
    <template #hero>
      <Hero @offer-created="loadOffers" />
    </template>

    <template #default>
      <div class="space-y-16">
        <VList :meta="meta">
          <template #before>
            <div class="hidden lg:flex font-medium text-sm text-gray-600 mb-4 pr-2">
              <div class="w-48 px-4">Issue Date</div>
              <div class="flex-1 px-4">Issuer</div>
              <div class="flex-1 px-4">Recipient</div>
              <div class="w-32 px-4 text-right">Ordered</div>
              <div class="w-32 px-4">Number</div>
              <div class="w-32 px-4 text-right mr-12">Amount</div>
            </div>
          </template>

          <template v-if="isLoading" #default>
            <div class="odd:bg-gray-100 border border-gray-200 rounded p-4 text-center">
              <Loader />
            </div>
          </template>

          <template v-else-if="isRejected" #default>
            <div class="odd:bg-red-100 border border-red-200 rounded p-4 text-red-600 text-center">
              Something went wrong. Please try again later.
            </div>
          </template>

          <template v-else-if="offers.length" #default>
            <template v-for="offer in offers">
              <VListLine :key="`offers_${offer.uuid}`" :offer="offer" :disabled="isLoading" />
            </template>
          </template>

          <template v-else #default>
            <div class="odd:bg-gray-100 border border-gray-200 rounded p-4 text-center">
              No results found
            </div>
          </template>
        </VList>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import { merge } from 'lodash-es';
import { mapGetters, mapState } from 'vuex';
import store from '@/store';
import VListVue from '@/components/Common/VList.vue';
import AccountListLineVue from '@/components/Offers/AccountListLine.vue';
import Hero from './components/IndexHero.vue';

const STATUS_IDLE = 'idle';
const STATUS_PENDING = 'pending';
const STATUS_RESOLVED = 'resolved';
const STATUS_REJECTED = 'rejected';

export default {
  components: {
    Hero,
    VList: VListVue,
    VListLine: AccountListLineVue,
  },

  props: {
    accountId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      status: STATUS_IDLE,
    };
  },

  computed: {
    ...mapGetters('ui/accountOffers', ['offers']),
    ...mapState('ui/accountOffers', ['meta']),
    isLoading() {
      return this.status === STATUS_PENDING;
    },
    isResolved() {
      return this.status === STATUS_RESOLVED;
    },
    isRejected() {
      return this.status === STATUS_REJECTED;
    },
  },

  async beforeRouteEnter(to, from, next) {
    const { accountId: accountUuid } = to.params;
    const { query } = to;
    const params = merge(query, { include: 'accountRelation,contact,offerLines,order' });

    try {
      await store.dispatch('ui/accountOffers/load', {
        accountUuid,
        params,
      });
      next();
    } catch (error) {
      next(false);
    }
  },

  methods: {
    async loadOffers() {
      const {
        params: { accountId: accountUuid },
        query,
      } = this.$route;

      const params = merge(query, { include: 'contact,offerLines,order' });

      try {
        await store.dispatch('ui/accountOffers/load', {
          accountUuid,
          params,
        });
      } catch (error) {
        //
      }
    },
  },
};
</script>
